import moment from 'moment';
import { ActionContext, Module } from 'vuex';
import { ApiResult, get, post, del, checkResult } from './api';

export interface State {
    imagesBasePath: string;
}

// Mutations

function setImagesBasePath(state: State, path: string) {
    state.imagesBasePath = path;
}

// Getters

function imagePathFromId(state: State) {
    return (id: string | number) => `${state.imagesBasePath}/${id}`;
}

function imageIdFromPath(state: State) {
    return (path: string) => path.replace(state.imagesBasePath+'/', '');
}

// Actions

async function uploadImage(ctx: ActionContext<State,any>, data: { file: File, id?: number }) {
    const endpoint = data.id ? `${ctx.state.imagesBasePath}/${data.id}` : ctx.state.imagesBasePath;

    type ResultType = ApiResult<{ image: { id: number }}>;

    let headers = {
        'Content-Type': data.file.type,
        'Content-Disposition': `attachment; filename="${data.file.name}"`
    }
    let result = await post(endpoint, data.file, headers).then(res => res.data as ResultType);

    return result;
    //return checkResult(result, ctx);
}


// Initial state and store options

export function initMediaModule(state?: State) {
    state = state || {
        imagesBasePath: '/images'
    };

    return <Module<State,any>> {
        namespaced: true,
        state,
        actions: {
            uploadImage,
        },
        mutations: {
            setImagesBasePath
        },
        getters: {
            imagePathFromId,
            imageIdFromPath
        }
    };
}

